import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "text-muted"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import CertManagerResourceTabs from '../components/CertManagerResourceTabs.vue';
import Tab from '@shell/components/Tabbed/Tab.vue';
import Banner from '@components/Banner/Banner.vue';
import ResourceTable from '@shell/components/ResourceTable.vue';
import SortableTable from '@shell/components/SortableTable/index.vue';
import DetailSummary, { SummaryItem } from '../components/DetailSummary.vue';
import { CHALLENGE_HEADERS } from '../table-headers';
import { useRelatedTypes } from '../composables/useRelatedTypes';
import { CERT_MANAGER } from '../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'acme.cert-manager.io.order',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

// Related resources are read from the store; a directly loaded detail page has none yet. Gate the
// related-data parts of the template on `loaded` so they render against the populated store.
const { loaded } = useRelatedTypes([CERT_MANAGER.CHALLENGE]);

const { t } = useI18n(useStore());

// Too long for the masthead, so they live with the authorizations they belong to
const acmeUrls = computed<SummaryItem[]>(() => [
  {
    label: t('certManager.order.url'), value: props.value.status?.url, href: props.value.status?.url
  },
  {
    label: t('certManager.order.finalizeUrl'), value: props.value.status?.finalizeURL, href: props.value.status?.finalizeURL
  },
]);

// Authorizations are derived summaries rather than store resources, so the identifier link is
// rendered through the cell slot below.
const authorizationHeaders = computed(() => [
  {
    name: 'identifier', labelKey: 'certManager.order.identifier', value: 'identifier', sort: ['identifier'],
  },
  {
    name: 'wildcard', labelKey: 'certManager.order.wildcard', value: (row: any) => (row.wildcard ? t('generic.yes') : t('generic.no')), sort: ['wildcard'],
  },
  {
    name: 'challengeTypes', labelKey: 'certManager.order.challengeTypes', value: (row: any) => (row.challengeTypes || []).join(', '),
  },
]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.value.status?.reason)
      ? (_openBlock(), _createBlock(Banner, {
          key: 0,
          color: __props.value.state === 'error' ? 'error' : 'info',
          label: __props.value.status.reason
        }, null, 8, ["color", "label"]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(CertManagerResourceTabs, { value: __props.value }, {
      default: _withCtx(() => [
        _createVNode(Tab, {
          name: "authorizations",
          label: _unref(t)('certManager.order.tab.authorizations'),
          weight: 30
        }, {
          default: _withCtx(() => [
            _createVNode(DetailSummary, { items: acmeUrls.value }, null, 8, ["items"]),
            _cache[0] || (_cache[0] = _createTextVNode()),
            (__props.value.authorizationSummaries.length)
              ? (_openBlock(), _createBlock(SortableTable, {
                  key: 0,
                  rows: __props.value.authorizationSummaries,
                  headers: authorizationHeaders.value,
                  "key-field": "identifier",
                  "default-sort-by": "identifier",
                  "table-actions": false,
                  "row-actions": false,
                  search: false,
                  paging: false
                }, {
                  "cell:identifier": _withCtx(({ row }) => [
                    (row.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: row.url,
                          target: "_blank",
                          rel: "noopener noreferrer nofollow"
                        }, _toDisplayString(row.identifier), 9, _hoisted_1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(row.identifier), 1))
                  ]),
                  _: 1
                }, 8, ["rows", "headers"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('certManager.order.noAuthorizations')), 1))
          ]),
          _: 1
        }, 8, ["label"]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createVNode(Tab, {
          name: "challenges",
          label: _unref(t)('certManager.order.tab.challenges'),
          weight: 20
        }, {
          default: _withCtx(() => [
            _createVNode(ResourceTable, {
              rows: _unref(loaded) ? __props.value.challenges : [],
              headers: _unref(CHALLENGE_HEADERS),
              "table-actions": false,
              groupable: false
            }, null, 8, ["rows", "headers"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})